<template>
	<div class="page" v-loading="loadingPage">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<router-link to="/contract/archive/add">
				<el-button type="success" round size="small">
					<span class="el-icon-plus"></span>
					上传合同
				</el-button>
			</router-link>
		</div>
		<div class="page-main">
			<el-card class="box-card">
				<div slot="header" class="flex justify-between align-center">
					<div>
						<span class="el-icon-search"></span>
						<span class="text-bold margin-left-sm">信息检索</span>
					</div>
				</div>
				<el-form :inline="true" :model="formSearch" class="demo-form-inline" label-suffix=":">
					<el-form-item label="合同编号"><el-input v-model="formSearch.data.id" clearable placeholder="合同编号,精准查找"></el-input></el-form-item>
					<el-form-item label="合同分类">
						<el-cascader
							:options="classListData"
							:show-all-levels="true"
							:props="{ value: 'id', label: 'name', emitPath: false }"
							v-model="formSearch.data.class"
							clearable
							placeholder="合同分类"
							@visible-change="getClassListData"
						></el-cascader>
					</el-form-item>
					<el-form-item label="客户名称"><el-input v-model="formSearch.data.customer" clearable placeholder="客户名称,支持模糊查询"></el-input></el-form-item>
					<el-form-item label="签约人">
						<el-tag
							size="small"
							type="info"
							disable-transitions
							:closable="signer ? true : false"
							@close="clearEmployee('signer')"
							@click="showCheckEmployee('signer')"
							v-if="signer"
						>
							<span>{{ signer.name }}({{ signer.officeid }})</span>
						</el-tag>
						<el-button size="medium" @click="showCheckEmployee('signer')" v-else>
							点击选择
							<i class="el-icon-arrow-down"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="签约时间">
						<el-date-picker
							v-model="formSearch.data.signtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="loadinfos">查询</el-button></el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card margin-top" :body-style="{ padding: '0px' }">
				<el-table :data="tableData" style="width: 100%" stripe v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
					<el-table-column prop="number" align="center" label="合同编号"></el-table-column>
					<el-table-column prop="customer" align="center" label="签约客户" min-width="220">
						<template slot-scope="scope">
							<div class="text-bold text-left">{{ scope.row.customer.name }}</div>
							<div class="text-grey text-left">{{ scope.row.customer.credit_code }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" label="联系人">
						<template slot-scope="scope">
							<span v-if="scope.row.contacter">{{ scope.row.contacter.name }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="合同分类" width="150">
						<template slot-scope="scope">
							<span v-if="scope.row.class_info">{{ scope.row.class_info.name }}</span>
							<span v-else class="cu-tag bg-gray radius">未分类</span>
						</template>
					</el-table-column>
					<el-table-column prop="sign_time" align="center" label="签约时间" width="180"></el-table-column>
					<el-table-column align="center" label="签约人" width="120">
						<template slot-scope="scope">
							<el-popover placement="top" trigger="click" @show="userCard_show(scope.row.signer.user_id)" v-if="scope.row.signer">
								<user-card :info="userCardInfo[scope.row.signer.user_id]"></user-card>
								<span slot="reference" class="text-link">{{ scope.row.signer.name }}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column align="center" label="归档状态" width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.stateflag == 1" class="cu-tag light bg-purple radius">待审核</span>
							<span v-else-if="scope.row.stateflag == 2" class="cu-tag light bg-green radius">已归档</span>
							<span v-else-if="scope.row.stateflag == 0" class="cu-tag light bg-orange radius">未提交</span>
							<span v-else-if="scope.row.stateflag == 9" class="cu-tag light bg-red radius">无效</span>
							<span v-else class="cu-tag light bg-gray radius">未知</span>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" align="center" label="上传时间" width="180"></el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<router-link :to="'/contract/archive/view/' + scope.row.id">
								<el-button size="small" type="primary">
									<span class="el-icon-view"></span>
									查看
								</el-button>
							</router-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="padding-tb text-right">
					<el-pagination
						background
						@size-change="pageSizeChange"
						@current-change="pageChange"
						:current-page="formSearch.page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="20"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-card>
		</div>
		<check-employee :show="checkEmployeeShow" :dKey="checkEmployeeKey" @close="checkEmployeeClose" @change="changeEmployee"></check-employee>
	</div>
</template>

<script>
import userCard from '@/components/user-card.vue';
import checkEmployee from '@/components/check-employee.vue';

export default {
	components: { userCard, checkEmployee },
	data() {
		return {
			classListData: [],
			checkEmployeeShow: false,
			checkEmployeeKey: null,
			signer: null,
			loadingPage: false,
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			total: 0,
			loading: false,
			tableData: [],
			options: [],
			popover_id: 0,
			userCardInfo: []
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadinfos();
		/* 		this.loadingPage = true;
		this.$http.post('/server/index.php?m=contract/archive&a=getPageDataList', {}).then(
			res => {
				this.loadingPage = false;
				if (res.result == 'ok') {
					this.loadinfos();
				} else {
					this.$alert(res.msg, {
						title: '操作错误',
						type: 'error'
					});
				}
			},
			r => {
				this.loadingPage = false;
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		); */
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		getClassListData(open) {
			if (this.classListData.length < 1 && open) {
				this.$http.post('/server/index.php?m=contract/archive&a=getClassList', {}).then(
					res => {
						if (res.result == 'ok') {
							this.classListData = res.data;
						} else {
							this.$message.error({ message: '获取分类列表信息失败：' + res.msg, offset: 250 });
						}
					},
					r => {
						this.$message.error({ message: '获取分类列表信息失败', offset: 250 });
					}
				);
			}
		},
		showCheckEmployee(key) {
			this.checkEmployeeShow = true;
			this.checkEmployeeKey = key;
		},
		checkEmployeeClose() {
			this.checkEmployeeShow = false;
		},
		changeEmployee(e) {
			this[e.key] = e.data;
		},
		clearEmployee(key) {
			this[key] = null;
		},
		userCard_show(id) {
			if (!this.userCardInfo[id]) {
				this.$http.post('/server/index.php?m=components/userCard&a=getInfo', { id: id }).then(
					res => {
						if (res.result == 'ok') {
							//Vue.set(this.userCardInfo,id,res.data);
							this.userCardInfo[id] = res.data;
							this.userCardInfo = Object.assign([], this.userCardInfo);
						} else {
						}
					},
					r => {
						console.log(r);
					}
				);
			}
		},
		change_signer(e) {
			console.log(e);
			return false;
		},
		loadinfos() {
			this.formSearch.data.signer = '';
			if (this.signer) {
				this.formSearch.data.signer = this.signer.id;
			}
			this.loading = true;
			this.$http.post('/server/index.php?m=contract/archive&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData = res.data.infos;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.loadinfos();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.loadinfos();
		}
	}
};
</script>

<style></style>
